import { render, staticRenderFns } from "./SpecialResourceType.vue?vue&type=template&id=6c315001"
import script from "./SpecialResourceType.vue?vue&type=script&lang=js"
export * from "./SpecialResourceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports